import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'bl-year-select',
    templateUrl: './year-select.component.html',
    styleUrls: ['./year-select.component.scss'],
    standalone: false
})
export class YearSelectComponent {
  @Input() value: number = new Date().getFullYear();
  @Output() prev = new EventEmitter<number>();
  @Output() next = new EventEmitter<number>();
  @Input() minYear?: number;
  @Input() maxYear?: number;

  constructor() {}

  onNext() {
    this.next.emit();
  }

  onPrev() {
    this.prev.emit();
  }

  get isPrevDisabled(): boolean {
    return this.value !== undefined && this.value <= this.minYear;
  }

  get isNextDisabled(): boolean {
    return this.value !== undefined && this.value >= this.maxYear;
  }
}
